import { ProgramCardDescription } from './Description'
import { ProgramCardImages } from './Images'
import { ProgramCardMoreBtn } from './MoreBtn'
import { ProgramCardTitle } from './Title'
import Link from 'next/link'

type Props = {
  title: string
  description: string
  href: string
  imgSize: {
    w: number
    h: number
  }
  cardRowNum: number
  imagePath: string
  size?: 'small' | 'medium'
  isAnimation?: boolean
}

export const ProgramCard = ({
  title,
  description,
  imgSize,
  cardRowNum,
  imagePath,
  size = 'medium',
  href,
}: Props): JSX.Element => {
  return (
    <div
      className={`flex flex-col justify-center items-center font-bold ${
        cardRowNum === 3
          ? size === 'small'
            ? 'lg:h-[20.2vw] h-[43.4vw] lg:mb-[3.4vw] mb-[4.8vw]'
            : 'h-[43.2vw] w-[24.8] mb-[4.8vw] lg:h-auto lg:mb-auto'
          : cardRowNum === 4
          ? size === 'small'
            ? 'h-[62vw] lg:h-[21.7vw]'
            : 'h-[62vw] lg:h-[26.9vw] lg:mx-[1.2vw]'
          : ''
      }`}
    >
      <Link href={href}>
        <a className="h-full">
          <div className="h-full rounded-[20px] shadow-button lg:hover:opacity-50">
            <ProgramCardTitle {...{ title, size, cardRowNum }} />
            {description && (
              <ProgramCardDescription {...{ description, cardRowNum, size }} />
            )}
            <ProgramCardImages
              {...{ imgSize, imagePath, size, cardRowNum, title }}
            />
            <ProgramCardMoreBtn {...{ size, cardRowNum }} />
          </div>
        </a>
      </Link>
    </div>
  )
}
